import React, { useEffect } from 'react';

declare global {
  interface Window {
    WOW: any;
    $: any;
    jQuery: any;
    Swiper: any;
  }
}

const About: React.FC = () => {
  const [showModal, setShowModal] = React.useState(false);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }

    // Initialize Magnific Popup for video
    if (window.$ && window.$.fn.magnificPopup) {
      window.$('.video-popup').magnificPopup({
        type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
            '</div>',
          patterns: {
            youtube: {
              index: 'youtube.com/',
              id: 'v=',
              src: 'https://www.youtube.com/embed/%id%?autoplay=1'
            }
          },
          srcAction: 'iframe_src',
        }
      });
    }
  }, []);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160 bg-image"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">About Us</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <a href="/">Home</a><span><i className="fa-regular fa-angles-right mx-2"></i>About Us</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {/* About area start here */}
      <section className="about-area pt-120 pb-120">
        <div className="container">
          <div className="row g-2 align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className="about__image">
                <div className="dots about-dot__animation">
                  <img src="/assets/images/shape/about-dot.png" alt="dots" />
                </div>
                <div className="sm-image">
                  <img src="/assets/images/about/about-image2.png" alt="Children care activity" />
                </div>
                <div className="image">
                  <img src="/assets/images/about/about-image1.png" alt="New Life Nepal care center" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-header mb-20">
                <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                  <i className="fa-regular fa-angles-left pe-1"></i> ABOUT US <i className="fa-regular fa-angles-right ps-1"></i>
                </h5>
                <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">What is New Life Nepal?</h2>
                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                  New Life Nepal is a non-profit, care-focused organization based in Nepal that works to support children and individuals who require daily care, supervision, and a safe living environment. We provide essential services that support dignity, stability, and long-term well-being.
                </p>
                <p className="wow fadeInUp" data-wow-delay="500ms" data-wow-duration="1500ms" style={{ marginTop: '15px' }}>
                  We specialize in caring for <strong>children with special needs</strong> including Down syndrome, cerebral palsy (CP), autism spectrum conditions, ADHD, and other developmental challenges. These children require long-term care and daily support with mobility, communication, learning, and self-care, receiving consistent supervision, assistance with hygiene, nutrition, medication, and structured routines.
                </p>
              </div>
              <div className="about__content">
                <div className="row g-4 mt-10 wow fadeInDown" data-wow-delay="200ms" data-wow-duration="1500ms">
                  <div className="col-6">
                    <h6 className="fs-14">
                      <svg className="me-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_20_5)">
                          <path
                            d="M17.4853 2.46073C17.2205 2.19547 16.7909 2.19502 16.5261 2.4596L8.38765 10.5765L5.45133 7.38742C5.1976 7.112 4.76863 7.09415 4.49276 7.34783C4.2171 7.60156 4.19945 8.03074 4.45317 8.3064L7.86776 12.0147C7.92961 12.082 8.00443 12.136 8.08771 12.1736C8.17099 12.2111 8.26101 12.2315 8.35235 12.2334C8.35731 12.2336 8.36209 12.2336 8.36683 12.2336C8.54636 12.2335 8.71855 12.1624 8.84577 12.0357L17.484 3.42018C17.7494 3.15563 17.7499 2.72598 17.4853 2.46073Z"
                            fill="#03A84A" />
                          <path
                            d="M17.3216 8.32159C16.9469 8.32159 16.6432 8.62527 16.6432 9C16.6432 13.2146 13.2146 16.6432 9 16.6432C4.78561 16.6432 1.35679 13.2146 1.35679 9C1.35679 4.78561 4.78561 1.35679 9 1.35679C9.3747 1.35679 9.67841 1.05311 9.67841 0.67841C9.67841 0.30368 9.3747 0 9 0C4.03734 0 0 4.03734 0 9C0 13.9624 4.03734 18 9 18C13.9624 18 18 13.9624 18 9C18 8.6253 17.6963 8.32159 17.3216 8.32159Z"
                            fill="#03A84A" />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Daily Care & Supervision
                    </h6>
                  </div>
                  <div className="col-6">
                    <h6 className="fs-14">
                      <svg className="me-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_20_5)">
                          <path
                            d="M17.4853 2.46073C17.2205 2.19547 16.7909 2.19502 16.5261 2.4596L8.38765 10.5765L5.45133 7.38742C5.1976 7.112 4.76863 7.09415 4.49276 7.34783C4.2171 7.60156 4.19945 8.03074 4.45317 8.3064L7.86776 12.0147C7.92961 12.082 8.00443 12.136 8.08771 12.1736C8.17099 12.2111 8.26101 12.2315 8.35235 12.2334C8.35731 12.2336 8.36209 12.2336 8.36683 12.2336C8.54636 12.2335 8.71855 12.1624 8.84577 12.0357L17.484 3.42018C17.7494 3.15563 17.7499 2.72598 17.4853 2.46073Z"
                            fill="#03A84A" />
                          <path
                            d="M17.3216 8.32159C16.9469 8.32159 16.6432 8.62527 16.6432 9C16.6432 13.2146 13.2146 16.6432 9 16.6432C4.78561 16.6432 1.35679 13.2146 1.35679 9C1.35679 4.78561 4.78561 1.35679 9 1.35679C9.3747 1.35679 9.67841 1.05311 9.67841 0.67841C9.67841 0.30368 9.3747 0 9 0C4.03734 0 0 4.03734 0 9C0 13.9624 4.03734 18 9 18C13.9624 18 18 13.9624 18 9C18 8.6253 17.6963 8.32159 17.3216 8.32159Z"
                            fill="#03A84A" />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Nutritious Meals
                    </h6>
                  </div>
                  <div className="col-6">
                    <h6 className="fs-14">
                      <svg className="me-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_20_5)">
                          <path
                            d="M17.4853 2.46073C17.2205 2.19547 16.7909 2.19502 16.5261 2.4596L8.38765 10.5765L5.45133 7.38742C5.1976 7.112 4.76863 7.09415 4.49276 7.34783C4.2171 7.60156 4.19945 8.03074 4.45317 8.3064L7.86776 12.0147C7.92961 12.082 8.00443 12.136 8.08771 12.1736C8.17099 12.2111 8.26101 12.2315 8.35235 12.2334C8.35731 12.2336 8.36209 12.2336 8.36683 12.2336C8.54636 12.2335 8.71855 12.1624 8.84577 12.0357L17.484 3.42018C17.7494 3.15563 17.7499 2.72598 17.4853 2.46073Z"
                            fill="#03A84A" />
                          <path
                            d="M17.3216 8.32159C16.9469 8.32159 16.6432 8.62527 16.6432 9C16.6432 13.2146 13.2146 16.6432 9 16.6432C4.78561 16.6432 1.35679 13.2146 1.35679 9C1.35679 4.78561 4.78561 1.35679 9 1.35679C9.3747 1.35679 9.67841 1.05311 9.67841 0.67841C9.67841 0.30368 9.3747 0 9 0C4.03734 0 0 4.03734 0 9C0 13.9624 4.03734 18 9 18C13.9624 18 18 13.9624 18 9C18 8.6253 17.6963 8.32159 17.3216 8.32159Z"
                            fill="#03A84A" />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Safe Living Environment
                    </h6>
                  </div>
                  <div className="col-6">
                    <h6 className="fs-14">
                      <svg className="me-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_20_5)">
                          <path
                            d="M17.4853 2.46073C17.2205 2.19547 16.7909 2.19502 16.5261 2.4596L8.38765 10.5765L5.45133 7.38742C5.1976 7.112 4.76863 7.09415 4.49276 7.34783C4.2171 7.60156 4.19945 8.03074 4.45317 8.3064L7.86776 12.0147C7.92961 12.082 8.00443 12.136 8.08771 12.1736C8.17099 12.2111 8.26101 12.2315 8.35235 12.2334C8.35731 12.2336 8.36209 12.2336 8.36683 12.2336C8.54636 12.2335 8.71855 12.1624 8.84577 12.0357L17.484 3.42018C17.7494 3.15563 17.7499 2.72598 17.4853 2.46073Z"
                            fill="#03A84A" />
                          <path
                            d="M17.3216 8.32159C16.9469 8.32159 16.6432 8.62527 16.6432 9C16.6432 13.2146 13.2146 16.6432 9 16.6432C4.78561 16.6432 1.35679 13.2146 1.35679 9C1.35679 4.78561 4.78561 1.35679 9 1.35679C9.3747 1.35679 9.67841 1.05311 9.67841 0.67841C9.67841 0.30368 9.3747 0 9 0C4.03734 0 0 4.03734 0 9C0 13.9624 4.03734 18 9 18C13.9624 18 18 13.9624 18 9C18 8.6253 17.6963 8.32159 17.3216 8.32159Z"
                            fill="#03A84A" />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Hygiene & Dignity Support
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-content-center flex-wrap gap-4 mt-40 wow fadeInDown"
                  data-wow-delay="400ms" data-wow-duration="1500ms">
                  <div className="btn-two">
                    <span className="btn-circle">
                    </span>
                 
                  </div>
               
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About area end here */}

      {/* Service area start here */}
      <section className="service-area pt-100 pb-100 sub-bg">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div className="service__item">
                <div className="service__icon"><img src="/assets/images/icon/service1.png" alt="icon" /></div>
                <div className="service__content">
                  <h3 className="text-white">Care & Supervision</h3>
                  <p className="text-white">Daily care through trained caretakers providing assistance, supervision, and personal support</p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className="service__item active">
                <div className="service__icon"><img src="/assets/images/icon/service2.png" alt="icon" /></div>
                <div className="service__content">
                  <h3 className="text-white">Nutrition & Daily Living</h3>
                  <p className="text-white">Providing regular, nutritious meals ensuring consistent nutrition and daily well-being</p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
              <div className="service__item">
                <div className="service__icon"><img src="/assets/images/icon/service3.png" alt="icon" /></div>
                <div className="service__content">
                  <h3 className="text-white">Hygiene & Dignity</h3>
                  <p className="text-white">Maintaining cleanliness, health, and personal dignity through essential hygiene support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Service area end here */}

      {/* About area start here */}
      <section className="about-two-area pt-120 pb-120 overflow-hidden">
        <div className="about-two__wrp">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-lg-6 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="about-two__image image pr-60">
                  <img src="/assets/images/about/about-two-image1.jpg" alt="Mission and vision section visual" />
                  <div className="line-shape sway_Y__animation">
                    <img src="/assets/images/shape/about-line.png" alt="shape" />
                  </div>
                  <div className="dot-shape sway__animation">
                    <img src="/assets/images/shape/about-dot3.png" alt="shape" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="section-header mb-20">
                  <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                    <i className="fa-regular fa-angles-left pe-1"></i> OUR MISSION & VISION <i className="fa-regular fa-angles-right ps-1"></i>
                  </h5>
                  <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Building a Caring and Inclusive Environment</h2>
                  <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                    Our mission is to provide consistent, compassionate, and practical care to children and individuals in need. We aim to create a stable environment where basic needs are met and individuals are treated with dignity and respect. We seek long-term sustainability through responsible care practices and trusted partnerships.
                  </p>
                </div>
                <div className="about-two__content">
                  <div className="item mb-30 wow fadeInDown" data-wow-delay="00ms" data-wow-duration="1500ms">
                    <div className="icon">
                      <img src="/assets/images/icon/about-icon1.png" alt="icon" />
                    </div>
                    <div className="content">
                      <h6 className="mb-10">International Partnerships</h6>
                      <p>We partner with volunteers and organizations from different countries who contribute time, skills, and experience to strengthen our capacity and build cross-cultural understanding</p>
                    </div>
                  </div>
                  <div className="item wow fadeInDown" data-wow-delay="200ms" data-wow-duration="1500ms">
                    <div className="icon">
                      <img src="/assets/images/icon/about-icon2.png" alt="icon" />
                    </div>
                    <div className="content">
                      <h6 className="mb-10">Transparency & Accountability</h6>
                      <p>We operate with full transparency through proper documentation, care notes, and reporting. We maintain strong relationships with donors and partners based on trust and shared values</p>
                    </div>
                  </div>
                  <div className="d-flex align-content-center flex-wrap gap-4 mt-40 wow fadeInDown"
                    data-wow-delay="400ms" data-wow-duration="1500ms">
                    <div className="btn-two">
                      <span className="btn-circle">
                      </span>
                      <button onClick={() => setShowModal(true)} className="btn-inner" style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                        <span className="btn-text">
                          ABOUT MORE
                        </span>
                      </button>
                    </div>
                    <div className="info-video">
                      <a href="https://www.youtube.com/watch?v=fdoou34qbTw" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-play"></i></a>
                      <h6>Intro Video</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About area end here */}

      {/* Modal */}
      {showModal && (
        <div 
          className="modal-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            padding: '20px',
            overflow: 'auto',
            animation: 'fadeIn 0.4s ease-in-out'
          }}
          onClick={() => setShowModal(false)}
        >
          <style>
            {`
              @keyframes fadeIn {
                from {
                  opacity: 0;
                }
                to {
                  opacity: 1;
                }
              }
              @keyframes slideUp {
                from {
                  opacity: 0;
                  transform: translateY(30px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
              @keyframes fadeInUp {
                from {
                  opacity: 0;
                  transform: translateY(20px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
              .modal-content {
                animation: slideUp 0.5s ease-out;
              }
              .modal-section {
                animation: fadeInUp 0.6s ease-out forwards;
                opacity: 0;
              }
              .modal-section:nth-child(1) { animation-delay: 0.1s; }
              .modal-section:nth-child(2) { animation-delay: 0.2s; }
              .modal-section:nth-child(3) { animation-delay: 0.3s; }
              .modal-section:nth-child(4) { animation-delay: 0.4s; }
              .modal-section:nth-child(5) { animation-delay: 0.5s; }
              .modal-section:nth-child(6) { animation-delay: 0.6s; }
              .modal-section:nth-child(7) { animation-delay: 0.7s; }
              .service-card {
                transition: transform 0.3s ease, box-shadow 0.3s ease;
              }
              .service-card:hover {
                transform: translateY(-5px);
                box-shadow: 0 5px 20px rgba(247, 79, 34, 0.2);
              }
            `}
          </style>
          <div 
            className="modal-content"
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '10px',
              maxWidth: '1400px',
              width: '95%',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: '#03A84A',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                fontSize: '24px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#01944B';
                e.currentTarget.style.transform = 'rotate(90deg)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#03A84A';
                e.currentTarget.style.transform = 'rotate(0deg)';
              }}
            >
              ×
            </button>

            <div style={{ padding: '50px 60px' }}>
              <div className="modal-section" style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h5 style={{ color: '#03A84A', fontSize: '18px', fontWeight: '600', marginBottom: '15px', letterSpacing: '1px' }}>
                  <i className="fa-regular fa-angles-left"></i> ABOUT NEW LIFE NEPAL <i className="fa-regular fa-angles-right"></i>
                </h5>
                <h2 style={{ color: '#0C2239', fontSize: '42px', fontWeight: '700', marginBottom: '20px' }}>
                  Who We Are
                </h2>
                <p style={{ color: '#6F7174', fontSize: '17px', lineHeight: '1.9', maxWidth: '1100px', margin: '0 auto 20px' }}>
                  New Life Nepal is a non-profit, care-focused organization based in Nepal. We work to support children and individuals who require daily care, supervision, and a safe living environment. Our activities focus on providing essential services that support dignity, stability, and long-term well-being.
                </p>
                <div style={{ backgroundColor: '#FFF5F2', padding: '30px', borderRadius: '12px', marginTop: '25px', maxWidth: '1100px', margin: '25px auto 0', border: '2px solid #03A84A' }}>
                  <h4 style={{ color: '#03A84A', fontSize: '22px', fontWeight: '600', marginBottom: '15px' }}>
                    <i className="fa-solid fa-heart-pulse" style={{ marginRight: '10px' }}></i>
                    Children with Special Needs
                  </h4>
                  <p style={{ color: '#0C2239', fontSize: '16px', lineHeight: '1.9', textAlign: 'left' }}>
                    New Life Nepal works with <strong>children with special needs</strong> who require long-term care and daily support due to physical, developmental, or intellectual conditions. These include children with <strong>Down syndrome, cerebral palsy (CP), autism spectrum conditions, attention deficit hyperactivity disorder (ADHD)</strong>, and other developmental challenges.
                  </p>
                  <p style={{ color: '#0C2239', fontSize: '16px', lineHeight: '1.9', marginTop: '15px', textAlign: 'left' }}>
                    Many of these children face difficulties with mobility, communication, learning, and daily self-care, and therefore need regular supervision, assistance with hygiene, nutrition, medication, and structured routines. We provide a safe and caring environment where trained caretakers offer consistent support, therapeutic activities, and emotional care, ensuring that each child is treated with dignity and given the opportunity to live a stable and supported life.
                  </p>
                </div>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px', padding: '30px', backgroundColor: '#FFF5F2', borderRadius: '10px', borderLeft: '5px solid #03A84A' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '15px' }}>
                  <i className="fa-solid fa-bullseye" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                  Our Mission
                </h4>
                <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                  The mission of New Life Nepal is to provide consistent, compassionate, and practical care to children and individuals in need. We aim to create a stable environment where basic needs are met and individuals are treated with dignity and respect.
                </p>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px', padding: '30px', backgroundColor: '#F0F8FF', borderRadius: '10px', borderLeft: '5px solid #03A84A' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '15px' }}>
                  <i className="fa-solid fa-eye" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                  Our Vision
                </h4>
                <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9' }}>
                  The vision of New Life Nepal is to build a caring and inclusive environment where vulnerable individuals receive the support they need to live safely and with dignity. We seek long-term sustainability through responsible care practices and trusted partnerships.
                </p>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '25px', textAlign: 'center' }}>
                  <i className="fa-solid fa-hands-holding-circle" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                  What We Do
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-hand-holding-heart" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Daily Care & Supervision
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      Trained caretakers provide daily assistance, supervision, and personal care including support with hygiene, routine activities, and overall safety.
                    </p>
                  </div>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-bowl-food" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Nutrition & Daily Living
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      Providing regular meals with staple foods such as rice and vegetables to ensure consistent nutrition and food planning.
                    </p>
                  </div>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-hand-sparkles" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Hygiene & Dignity
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      Hygiene supplies including adult diapers where required to maintain cleanliness, health, and personal dignity.
                    </p>
                  </div>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-puzzle-piece" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Therapeutic Support
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      Therapeutic materials used to support daily activities and care routines to improve engagement and quality of life.
                    </p>
                  </div>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-clipboard-check" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Administration & Records
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      Basic stationery and administrative tools for daily records, care notes, reporting, and coordination with partners.
                    </p>
                  </div>
                  <div className="service-card" style={{ padding: '30px', backgroundColor: '#F9F9F9', borderRadius: '10px', border: '2px solid transparent' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                      <i className="fa-solid fa-house-heart" style={{ fontSize: '28px', color: '#03A84A' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                      Safe Environment
                    </h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>
                      A safe and supportive living environment where individuals are treated with compassion and respect.
                    </p>
                  </div>
                </div>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px', padding: '35px', backgroundColor: '#E8F4FD', borderRadius: '10px', border: '2px solid #3498db' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '25px', textAlign: 'center' }}>
                  <i className="fa-solid fa-users" style={{ color: '#3498db', marginRight: '12px' }}></i>
                  Who We Serve
                </h4>
                <p style={{ color: '#0C2239', fontSize: '17px', lineHeight: '1.9', marginBottom: '25px', textAlign: 'center', maxWidth: '1000px', margin: '0 auto 25px' }}>
                  We provide specialized care for children facing various physical, developmental, and intellectual challenges, as well as orphaned children who need a loving home:
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-dna" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Down Syndrome</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Providing specialized support for children with Down syndrome, focusing on their unique developmental needs</p>
                  </div>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-wheelchair" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Cerebral Palsy (CP)</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Assisting children with cerebral palsy through mobility support, physical therapy, and daily care</p>
                  </div>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-puzzle-piece" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Autism Spectrum</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Creating structured environments and routines for children with autism spectrum conditions</p>
                  </div>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-brain" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>ADHD</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Supporting children with attention deficit hyperactivity disorder through consistent care and guidance</p>
                  </div>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-heart-pulse" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Developmental Challenges</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Caring for children with various other developmental challenges requiring long-term support</p>
                  </div>
                  <div style={{ padding: '25px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 3px 15px rgba(52, 152, 219, 0.1)' }}>
                    <div style={{ width: '60px', height: '60px', backgroundColor: '#E8F4FD', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                      <i className="fa-solid fa-hand-holding-heart" style={{ fontSize: '28px', color: '#3498db' }}></i>
                    </div>
                    <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Orphaned Children</h6>
                    <p style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Providing a loving home for children without parents, including education, food, clothing, shelter, and complete care</p>
                  </div>
                </div>
                <div style={{ marginTop: '30px', padding: '25px', backgroundColor: 'white', borderRadius: '10px', borderLeft: '4px solid #3498db' }}>
                  <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                    <i className="fa-solid fa-hand-holding-heart" style={{ color: '#3498db', marginRight: '10px' }}></i>
                    Our Specialized Support Includes:
                  </h6>
                  <ul style={{ color: '#6F7174', fontSize: '15px', lineHeight: '2', marginLeft: '20px' }}>
                    <li><strong>Mobility Assistance:</strong> Support for children with physical limitations</li>
                    <li><strong>Communication Support:</strong> Helping children express themselves effectively</li>
                    <li><strong>Learning Support:</strong> Adapted educational activities and cognitive development</li>
                    <li><strong>Daily Self-Care:</strong> Assistance with hygiene, nutrition, and medication</li>
                    <li><strong>Structured Routines:</strong> Consistent schedules that provide stability and security</li>
                    <li><strong>Therapeutic Activities:</strong> Engaging activities that promote development and well-being</li>
                    <li><strong>Emotional Care:</strong> Creating a nurturing environment where every child feels valued</li>
                  </ul>
                </div>
                <div style={{ marginTop: '20px', padding: '25px', backgroundColor: '#FFF5F2', borderRadius: '10px', borderLeft: '4px solid #03A84A' }}>
                  <h6 style={{ color: '#0C2239', fontSize: '18px', fontWeight: '600', marginBottom: '12px' }}>
                    <i className="fa-solid fa-home" style={{ color: '#03A84A', marginRight: '10px' }}></i>
                    Complete Care for Orphaned Children:
                  </h6>
                  <ul style={{ color: '#6F7174', fontSize: '15px', lineHeight: '2', marginLeft: '20px' }}>
                    <li><strong>Education:</strong> Ensuring every child attends school and receives quality education</li>
                    <li><strong>Nutritious Food:</strong> Three healthy meals daily plus snacks to support growth</li>
                    <li><strong>Clothing:</strong> Providing appropriate clothing for all seasons and occasions</li>
                    <li><strong>Safe Shelter:</strong> A secure, comfortable home environment with proper facilities</li>
                    <li><strong>Healthcare:</strong> Regular medical checkups, vaccinations, and treatment when needed</li>
                    <li><strong>Emotional Support:</strong> Creating a family-like atmosphere with love and guidance</li>
                    <li><strong>Life Skills:</strong> Teaching independence and preparing them for future success</li>
                    <li><strong>Recreational Activities:</strong> Sports, arts, and play for holistic development</li>
                  </ul>
                </div>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px', padding: '35px', backgroundColor: '#F9FAFB', borderRadius: '10px' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '20px', textAlign: 'center' }}>
                  <i className="fa-solid fa-heart-circle-check" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                  Our Values & Approach
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ width: '50px', height: '50px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px', flexShrink: 0 }}>
                      <i className="fa-solid fa-heart" style={{ color: '#03A84A', fontSize: '22px' }}></i>
                    </div>
                    <div>
                      <strong style={{ color: '#0C2239', fontSize: '16px', display: 'block', marginBottom: '5px' }}>Compassion and respect</strong>
                      <span style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>In all our interactions with individuals and partners</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ width: '50px', height: '50px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px', flexShrink: 0 }}>
                      <i className="fa-solid fa-arrows-rotate" style={{ color: '#03A84A', fontSize: '22px' }}></i>
                    </div>
                    <div>
                      <strong style={{ color: '#0C2239', fontSize: '16px', display: 'block', marginBottom: '5px' }}>Consistency in care</strong>
                      <span style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Through dedicated caretakers and daily support</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ width: '50px', height: '50px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px', flexShrink: 0 }}>
                      <i className="fa-solid fa-hand-holding-dollar" style={{ color: '#03A84A', fontSize: '22px' }}></i>
                    </div>
                    <div>
                      <strong style={{ color: '#0C2239', fontSize: '16px', display: 'block', marginBottom: '5px' }}>Responsible use of resources</strong>
                      <span style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>To maximize impact and sustainability</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ width: '50px', height: '50px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px', flexShrink: 0 }}>
                      <i className="fa-solid fa-shield-check" style={{ color: '#03A84A', fontSize: '22px' }}></i>
                    </div>
                    <div>
                      <strong style={{ color: '#0C2239', fontSize: '16px', display: 'block', marginBottom: '5px' }}>Transparency in operations</strong>
                      <span style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Through proper documentation and accountability</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ width: '50px', height: '50px', backgroundColor: '#FFF5F2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px', flexShrink: 0 }}>
                      <i className="fa-solid fa-chart-line" style={{ color: '#03A84A', fontSize: '22px' }}></i>
                    </div>
                    <div>
                      <strong style={{ color: '#0C2239', fontSize: '16px', display: 'block', marginBottom: '5px' }}>Long-term impact</strong>
                      <span style={{ color: '#6F7174', fontSize: '15px', lineHeight: '1.7' }}>Over short-term solutions for lasting change</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-section" style={{ marginBottom: '40px', padding: '35px', backgroundColor: '#FFF5F2', borderRadius: '10px' }}>
                <h4 style={{ color: '#0C2239', fontSize: '28px', fontWeight: '600', marginBottom: '20px' }}>
                  <i className="fa-solid fa-globe" style={{ color: '#03A84A', marginRight: '12px' }}></i>
                  International Support & Volunteers
                </h4>
                <p style={{ color: '#6F7174', fontSize: '16px', lineHeight: '1.9', marginBottom: '20px' }}>
                  New Life Nepal partners with volunteers from different countries who contribute time, skills, and experience. These volunteers support the organization in various ways, including care assistance, knowledge sharing, and general support activities. International partnerships play an important role in strengthening our capacity and building cross-cultural understanding.
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginTop: '20px' }}>
                  <div style={{ textAlign: 'center', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
                    <i className="fa-solid fa-users" style={{ fontSize: '32px', color: '#03A84A', marginBottom: '10px' }}></i>
                    <p style={{ color: '#0C2239', fontWeight: '600', fontSize: '15px', marginBottom: '5px' }}>Care Assistance</p>
                    <p style={{ color: '#6F7174', fontSize: '13px' }}>Direct support to individuals</p>
                  </div>
                  <div style={{ textAlign: 'center', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
                    <i className="fa-solid fa-book-open-reader" style={{ fontSize: '32px', color: '#03A84A', marginBottom: '10px' }}></i>
                    <p style={{ color: '#0C2239', fontWeight: '600', fontSize: '15px', marginBottom: '5px' }}>Knowledge Sharing</p>
                    <p style={{ color: '#6F7174', fontSize: '13px' }}>Training and education</p>
                  </div>
                  <div style={{ textAlign: 'center', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
                    <i className="fa-solid fa-hands-holding" style={{ fontSize: '32px', color: '#03A84A', marginBottom: '10px' }}></i>
                    <p style={{ color: '#0C2239', fontWeight: '600', fontSize: '15px', marginBottom: '5px' }}>General Support</p>
                    <p style={{ color: '#6F7174', fontSize: '13px' }}>Administrative help</p>
                  </div>
                </div>
              </div>

              <div className="modal-section" style={{ textAlign: 'center', marginTop: '40px', padding: '40px', background: 'linear-gradient(135deg, #03A84A 0%, #01944B 100%)', borderRadius: '12px', color: 'white' }}>
                <i className="fa-solid fa-hand-holding-heart" style={{ fontSize: '48px', marginBottom: '20px', display: 'block' }}></i>
                <h3 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '15px', color: 'white' }}>
                  Together, We Can Make a Difference
                </h3>
                <p style={{ fontSize: '17px', marginBottom: '30px', color: 'rgba(255, 255, 255, 0.95)', maxWidth: '700px', margin: '0 auto 30px' }}>
                  Support our mission to provide care, dignity, and hope to those in need. Every contribution helps us continue our vital work.
                </p>
                <a 
                  href="/contact" 
                  className="btn-inner"
                  style={{
                    display: 'inline-block',
                    padding: '18px 50px',
                    backgroundColor: 'white',
                    color: '#03A84A',
                    fontSize: '18px',
                    fontWeight: '600',
                    borderRadius: '50px',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
                  }}
                  onClick={() => setShowModal(false)}
                >
                  <i className="fa-solid fa-heart" style={{ marginRight: '10px' }}></i>
                  DONATE NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default About;
